import {Injectable} from '@angular/core';
import {Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {Appointment} from "../shared/models/appointment";
import {DataStoreService} from "../shared/services/api/data-store.service";
import {Report} from '../shared/models/report';

@Injectable()
export class ReportResolverService implements Resolve<Report> {
  constructor(private dataStore: DataStoreService,
              private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {

    let id = route.params['id'];
    if (id) {
      let report = this.dataStore.peekRecord(Report, id);
      if (report) {
        return report;
      } else {
        return this.dataStore.findRecord(Report, id);
      }
    } else {
      return true;
    }

  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/report/report-resolver.service.ts